<script>
export default {
  props: {
    name: String,
    colors: Array,
    active: Boolean,
  },
  methods: {
    gradientString() {
      return "linear-gradient(30deg," + this.colors.toString() + ")";
      //   return "linear-gradient(30deg, blue, red)";
    },
  },
};
</script>

<template>
  <v-card
    :variant="active ? 'outlined' : 'text'"
    :style="{ backgroundImage: gradientString() }"
    @click="$emit('select', name)"
  >
    <v-card-title>{{ name }}</v-card-title>
    <v-card-actions>
      <v-btn
        @click="$emit('edit', name)"
        :variant="active ? 'outlined' : 'text'"
        :rounded="active"
        :style="{ backgroundColor: '#16161d40' }"
        >Edit Preset</v-btn
      >
      <v-spacer />
    </v-card-actions>
  </v-card>
</template>